import { render, staticRenderFns } from "./BasePopupModal.vue?vue&type=template&id=3b720768"
import script from "./BasePopupModal.vue?vue&type=script&lang=js"
export * from "./BasePopupModal.vue?vue&type=script&lang=js"
import style0 from "./BasePopupModal.vue?vue&type=style&index=0&id=3b720768&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports